// extracted by mini-css-extract-plugin
module.exports = {"spotlights":"style_spotlights__1qx8I","spotlight":"style_spotlight__1m7Xh","tag":"style_tag__3Wttu"};